// import { HttpResponse } from '@angular/common/http';
import { Component, ElementRef, Injector, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { takeUntil } from 'rxjs/operators';
import { EstoqueService } from '../../almoxarifado/estoque/service/estoque.service';
import { SetorService } from '../../almoxarifado/setor/service/setor.service';
import { ProgressoService } from '../../components/progresso/service/progresso.service';
import { Sistemas } from '../../components/types';
import { Estoque } from '../../entidade/almoxarifado/estoque.model';
import { Setor } from '../../entidade/almoxarifado/setor.model';
import { UsuarioEstoque } from '../../entidade/almoxarifado/usuario-estoque.model';
import { UsuarioSetor } from '../../entidade/almoxarifado/usuario-setor.model';
import { Favorecido } from '../../entidade/compra/favorecido.model';
import { Acesso } from '../../entidade/comum/acesso.model';
import { Pagina } from '../../entidade/comum/pagina';
import { Usuario } from '../../entidade/comum/usuario.model';
import { LoginContabil } from '../../entidade/login/login-contabil';
import { Unidade } from '../../entidade/planejamento/unidade.model';
import { FavorecidoService } from '../../favorecido/service/favorecido.service';
import { BaseResourceFormComponent } from '../../models/base-resource-form';
import { EddyAutoComplete } from '../../models/form-components';
import { UnidadeService } from '../../unidade/service/unidade.service';
import { FuncaoService } from '../../util/funcao.service';
import { GlobalService } from '../../util/global.service';
import { AcessoService } from '../service/acesso.service';
import { UsuarioService } from '../service/usuario.service';
import { UsuarioSetorService } from '../service/usuario-setor.service';
import { AudespFasesService } from '../../util/audesp-fase.service';
import { PerfilAssinatura } from 'eddydata-lib';
import { PerfilAssinaturaService } from '../../orgao/service/perfil-assinatura.service';
import { TermoAcessoUsuarioAceite } from '../../entidade/comum/termo-acesso-usuario-aceite.model';
import { TermoAcessoUsuarioAceiteService } from '../service/termo-acesso-usuario-aceite.service';
import { error, info, success, warning } from 'toastr';

declare var $: any;

@Component({
  selector: 'lib-usuario-form',
  templateUrl: './usuario-form.component.html',
  styleUrls: ['./usuario-form.component.css']
})
export class UsuarioFormComponent extends BaseResourceFormComponent<Usuario, LoginContabil> {

  /**
   * Declaração de variáveis
   */
  @ViewChild('tipo_') inputField: ElementRef;

  public setorAutoComplete: EddyAutoComplete<Setor>;
  public estoqueAutoComplete: EddyAutoComplete<Estoque>;
  public unidadeAutoComplete: EddyAutoComplete<Unidade>;
  public favorecidoAutoComplete: EddyAutoComplete<Favorecido>;
  public acessos: { sistema: Sistemas, acessos: Acesso[] }[];
  public opcoesAcesso: any[] = [
    { label: 'Sem acesso', value: 0, icon: 'lock_break.png' },
    { label: 'Visualizar', value: 1, icon: 'zoom.png' },
    { label: 'Incluir/Alterar', value: 2, icon: 'pencil.png' }
  ];
  public listaSistemas: { id: Sistemas, nome: string }[];
  public sistemasAdministrador: string[] = [];
  public sistemasAlterados: { adicionados: string, removidos: string } = { adicionados: '', removidos: '' };
  public listaUsuariosCC: Usuario[];
  public acessosCC: Acesso[];
  public estoqueAtual: Estoque;
  public setorAtual: Setor;
  public listaHistorico: Array<any>;
  public listaTermos: Array<TermoAcessoUsuarioAceite> = [];

  public indexSelecionado: number;
  public liberaCampoSetor = true;

  public audesp: boolean = false;
  public dadosAudesp: any;
  public listaPerfis: PerfilAssinatura[] = [];
  public perfis: PerfilAssinatura[] = [];
  public listaEstoque: Estoque[] = [];
  public listaSetor: Setor[] = [];

  public paginaCorrente: number = 1;
  public paginaTotal: number;
  public limite: number = 20;

  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    protected injector: Injector,
    protected messageService: MessageService,
    public globalService: GlobalService,
    protected funcaoService: FuncaoService,
    protected acessoService: AcessoService,
    protected setorService: SetorService,
    protected estoqueService: EstoqueService,
    protected unidadeService: UnidadeService,
    protected favorecidoService: FavorecidoService,
    protected audespService: AudespFasesService,
    protected progressoService: ProgressoService,
    protected perfilAssinaturaService: PerfilAssinaturaService,
    protected usuarioSetorService: UsuarioSetorService,
    protected usuarioService: UsuarioService,
    protected termoAcessoUsuarioAceiteService: TermoAcessoUsuarioAceiteService
  ) {
    super(new Usuario(), injector, Usuario.converteJson, usuarioService);
  }

  protected criarCamposForm(): void {
    this.entidadeForm = this.fb.group({
      id: [null],
      nome: [null, [Validators.required, Validators.minLength(2)]],
      sobrenome: [null, [Validators.required, Validators.minLength(2)]],
      email: [null, [Validators.required, Validators.minLength(2)]],
      senha: [null],
      sistema: [null],
      cpf: [null, [Validators.required]],
      telefone: [null, [Validators.required]],
      ativo: [null],
      convidado: [null, [Validators.required]],
      administrador: [null, [Validators.required]],
      controle_interno: [false, [Validators.required]],
      sabado: [true],
      domingo: [true],
      solicitacao: [null],
      setor: [null],
      estoque: [null],
      unidade: [null],
      favorecido: [null],
      horario_inicio: [null],
      horario_termino: [null],
      orgao: [null, [Validators.required]],
      acessos: [null],
      usuario_estoques: [[]],
      sistemas_administrador: [null],
      usuario_perfis_assinatura: [[]],
      usuario_setores: [[]],
      login_audesp: [null],
      senha_audesp: [null],
      eddydata: [false],
      tipo_chave: [null],
      caminho_a1: [null],
      perfil_assinatura: [null],
      vincular_recurso_siconfi: [false],
      atualizar_termo: [false],
      sistemas_administrador_alterados: [null],
    });
  }

  protected parametrosExtras(): {} {
    return {
      relations: 'orgao,acessos,setor,estoque,favorecido,unidade,usuario_estoques.estoque,usuario_perfis_assinatura.perfil_assinatura'
    };
  }

  protected async afterLoad() {
    if (this.entidade.sistemas_administrador)
      this.sistemasAdministrador = this.entidade.sistemas_administrador.split(',')
    else
      this.sistemasAdministrador = [];
    this.preencherAcessos(this.entidade.acessos);

    // this.acessoService.filtrar(1, -1, { 'usuario.id': this.entidade.id })
    //   .subscribe(res => {
    //     this.entidade.acessos = res.content;

    //     this.preencherAcessos(this.entidade.acessos);
    //   });

    this.carregarAutoCompletes();

    this.entidadeForm.get('estoque').setValue(this.entidade.estoque);
    this.entidadeForm.get('usuario_estoques').setValue(this.entidade.usuario_estoques);

    this.usuarioSetorService.filtrar(1, -1, {
      'usuario.id': this.entidade.id,
      relations: 'setor',
    }).subscribe(res => {
      const usuario_setores = res.content as UsuarioSetor[];
      this.entidade.usuario_setores = usuario_setores.map<UsuarioSetor>(usuarioSetor => {
        const { id, nome, codigo } = usuarioSetor.setor;
        const setor: Setor = { id, nome, codigo };

        return {
          usuario: { id: this.entidade.id },
          setor
        };
      });
    });

    if (this.entidade.id == this.login.usuario.id) {
      this.audesp = true;
    }

    this.estoqueService.filtrar(1, -1, { 'orgao.id': this.login.orgao.id }).pipe(takeUntil(this.unsubscribe))
      .subscribe(dados => {
        this.listaEstoque = dados.content;
      });

    this.setorService.filtrar(1, -1, { 'orgao.id': this.login.orgao.id }).pipe(takeUntil(this.unsubscribe))
      .subscribe(dados => {
        this.listaSetor = dados.content;
      });

    this.ativarSetores();
    this.preencherPerfis();
  }

  protected afterInit(): void {
    this.listaSistemas = this.globalService.obterListaSistemas();
    this.perfilAssinaturaService
      .filtrar(
        1,
        -1,
        { 'orgao.id': this.login.orgao.id, orderBy: 'nome' }
      )
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        dados => {
          this.listaPerfis = dados.content;
          this.preencherPerfis();
        }
      );
    this.carregarAutoCompletes();
  }

  protected campoFoco(): ElementRef {
    return this.inputField;
  }

  protected beforeSubmit(): void {
    this.entidadeForm.get('sistemas_administrador').setValue(this.sistemasAdministrador.join(','));
    this.entidadeForm.get('acessos').setValue(this.unificarPermissoes());
    this.entidadeForm.get('usuario_estoques').setValue(this.entidade.usuario_estoques);
    this.entidadeForm.get('usuario_setores').setValue(this.entidade.usuario_setores);
    this.entidade.usuario_perfis_assinatura = this.perfis.map(perfil => ({
      perfil_assinatura: perfil
    }));

    this.entidadeForm.get('usuario_perfis_assinatura')?.setValue(this.entidade.usuario_perfis_assinatura);

    const horario_inicio = this.entidadeForm.get('horario_inicio').value
    const horario_termino = this.entidadeForm.get('horario_termino').value
    const administrador = this.entidadeForm.get('administrador').value

    if (this.entidade.id && this.entidade.sistemas_administrador != this.entidadeForm.get('sistemas_administrador').value) {
      this.sistemasAlterados = this.compararSistemasAdministrador(this.entidade.sistemas_administrador, this.entidadeForm.get('sistemas_administrador').value);
      this.entidadeForm.get('atualizar_termo').setValue(true);
      this.entidadeForm.get('sistemas_administrador_alterados').setValue(this.sistemasAlterados);
    }

    try {
      if (administrador && (horario_inicio || horario_termino)) {
        throw new Error('Administrador do Sistema não deve possuir restrição a horario de acesso')
      }
      if ((!horario_inicio && horario_termino) || (horario_inicio && !horario_termino)) {
        throw new Error('Preencha corretamente os dois campos de "Horário de acesso"')
      }
      if (horario_inicio > horario_termino) {
        throw new Error('O horário inicial não pode ser maior que o horario final')
      }
    } catch (e) {
      this.funcaoService.acaoErro(e);
      throw e;
    }
  }

  private compararSistemasAdministrador(entidadeValor: string | null | undefined, formValor: string | null | undefined): { adicionados: string, removidos: string } {
    const normalize = (s: string | null | undefined): string[] => {
      if (!s) return [];
      return s.split(',')
        .map(item => item?.trim())
        .filter(item => item && item.length > 0) as string[];
    };

    const original = new Set(normalize(entidadeValor));
    const atual = new Set(normalize(formValor));

    const adicionadosArr: string[] = [];
    const removidosArr: string[] = [];

    // itens presentes no form e não na entidade => adicionados
    for (const s of atual) {
      if (!original.has(s)) adicionadosArr.push(s);
    }

    // itens presentes na entidade e não no form => removidos
    for (const s of original) {
      if (!atual.has(s)) removidosArr.push(s);
    }

    return {
      adicionados: adicionadosArr.join(',') || '',
      removidos: removidosArr.join(',') || ''
    };
  }

  protected afterSubmit(entidade: Usuario): void {
    this.mensagemSucesso = `Registro salvo com sucesso!`;
    // this.acessoService.filtrar(0, 0, { usuario_id: entidade.id }).pipe(takeUntil(this.unsubscribe))
    //   .subscribe((data) => {
    //     if (data?.content) {
    //       this.entidade.acessos = data.content;
    //       this.afterLoad()
    //     }
    //   }, e => error(e.error.message));
    this.loadResource()
  }

  // ========================================================================
  //                            MÉTODOS DA CLASSE
  // ========================================================================

  public verificaCheck() {
    if (this.entidadeForm.get('administrador').value) {
      this.entidadeForm.get('convidado').setValue(false);
    }

    if (this.entidadeForm.get('convidado').value) {
      this.entidadeForm.get('administrador').setValue(false);
    }

    this.revelaHorarioAcesso()
  }

  public carregarAutoCompletes() {
    // autocomplete para setor
    this.setorAutoComplete = new EddyAutoComplete(this.entidadeForm.get('setor'), this.setorService,
      'id', ['codigo', 'nome'], this.carregarParametrosSetor(), { text: ['nome', 'codigo'] });

    // autocomplete para estoque
    this.estoqueAutoComplete = new EddyAutoComplete(this.entidadeForm.get('estoque'), this.estoqueService,
      'id', ['nome'],
      { orgao_id: this.login.orgao.id, ativo: true, orderBy: 'nome' }, { text: ['nome'] });

    // autocomplete para favorecido
    this.favorecidoAutoComplete = new EddyAutoComplete(this.entidadeForm.get('favorecido'), this.favorecidoService,
      'id', ['nome'], { cidade_id: this.login.cidade.id, orderBy: 'nome' }, { number: ['id', 'cpf_cnpj'], text: ['nome'] });

    // autocomplete para unidade administrativa 3 setor
    this.unidadeAutoComplete = new EddyAutoComplete(this.entidadeForm.get('unidade'), this.unidadeService,
      'id', ['codigo', 'nome'], { ppa_id: this.login.ppa.id, orderBy: 'nome' }, { number: ['codigo'], text: ['nome'] });
  }

  private carregarParametrosSetor() {
    let joinEstoques = "";
    if (this.entidade.usuario_estoques) {
      joinEstoques = this.entidade.usuario_estoques.map(ue => ue.estoque.id).join(",");
    }

    if (this.entidadeForm.get('estoque').value || this.entidade.estoque) {
      if (joinEstoques) {
        joinEstoques += "," + (this.entidadeForm.get('estoque').value ? this.entidadeForm.get('estoque').value?.id : this.entidade.estoque?.id);
      } else {
        joinEstoques += (this.entidadeForm.get('estoque').value ? this.entidadeForm.get('estoque').value?.id : this.entidade.estoque?.id);
      }
    }

    let parametros = { orgao_id: this.login.orgao.id, relations: 'unidade,orgao,estoques', orderBy: 'nome' };
    parametros['estoques.estoque.id$in'] = joinEstoques;

    return parametros;
  }

  autorizar() {
    this.entidade = this.entidadeForm.value;

    const solicitacao = this.entidade.solicitacao;
    const ativo = this.entidade.ativo;

    this.entidade.solicitacao = false;
    this.entidade.ativo = true;

    this.usuarioService.autorizar(this.entidade).pipe(takeUntil(this.unsubscribe))
      .subscribe((data) => {
        this.entidadeForm.get('solicitacao').setValue(this.entidade.solicitacao);
        this.entidadeForm.get('ativo').setValue(this.entidade.ativo);
        this.submitForm();
      }, e => {
        this.entidade.solicitacao = solicitacao;
        this.entidade.ativo = ativo;
        error(e.error.message);
      });
  }

  private unificarPermissoes(): Acesso[] {
    const retorno: Acesso[] = [];

    // unifica os acessos dos sistemas em um só para ser salvo
    for (const acesso of this.acessos) {
      for (const acessoPagina of acesso.acessos) {
        retorno.push(acessoPagina);
      }
    }

    return retorno;
  }

  public carregarUsuariosCC() {
    this.usuarioService.filtrar(1, -1, {
      'orgao.id': this.login.orgao.id,
      id$ne: this.entidade.id,
      convidado: false,
      relations: 'acessos',
      orderBy: 'nome'
    }).pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.listaUsuariosCC = res ? res.content : [];
      }, e => error('Atenção', e));
  }

  public importarPermissoes() {
    if (!this.acessosCC || this.acessosCC.length === 0) {
      warning('Selecione o usuário a ter as suas permissões importadas!');
      return;
    }

    const acessos: Acesso[] = this.unificarPermissoes();
    for (const acessoCC of this.acessosCC) {
      for (const acesso of acessos) {
        if (acessoCC.pagina === acesso.pagina) {
          acesso.permissao = acessoCC.permissao;
        }
      }
    }

    this.preencherAcessos(acessos);
    info('Permissões importadas!');
  }

  public preencherAcessos(acessosEntidade: Acesso[]) {
    const acessosTotal: Acesso[] = [];

    // unifica todas as paginas em um objeto para percorrer do banco de dados e criar os que nao existirem
    let paginas = this.acessoService.retornaTodasPaginas();

    for (const pagina of paginas) {
      let encontrou = false;
      if (acessosEntidade) {
        for (const acesso of acessosEntidade) {
          if (acesso.pagina === Pagina[pagina]) {
            acesso.usuario = this.login.usuario;
            acesso.nomePagina = pagina;
            acessosTotal.push(acesso);
            encontrou = true;
            break;
          }
        }
      }

      if (!encontrou) {
        const acesso = new Acesso();
        acesso.id = null;
        acesso.pagina = Pagina[pagina];
        acesso.permissao = 0;
        acesso.usuario = this.login.usuario;
        acesso.nomePagina = pagina;
        acessosTotal.push(acesso);
      }
    }

    // atribuir os acessos por sistema
    this.acessos = this.acessoService.agruparAcessosPorSistema(acessosTotal, this.login.usuario.sistemas_administrador ? this.login.usuario.sistemas_administrador : ' ');

    this.entidadeForm.get('acessos').setValue(this.acessos);
  }

  public adicionarUsuarioEstoque() {
    if (!this.estoqueAtual) return;
    if (!this.entidade.usuario_estoques) this.entidade.usuario_estoques = [];

    if (this.entidade.usuario_estoques.find(m => m.estoque.id === this.estoqueAtual.id)) {
      warning(`Estoque ${this.estoqueAtual.nome} já vinculado ao usuário!`);
    } else {
      this.entidade.usuario_estoques.push({ estoque: this.estoqueAtual });
    }

    this.estoqueAtual = undefined
    this.carregarAutoCompletes();
  }

  public removerUsuarioEstoque(item: UsuarioEstoque, index: number) {
    if (!item) return
    this.entidade.usuario_estoques.splice(index, 1);
    this.carregarAutoCompletes();
  }

  public adicionarUsuarioSetor() {
    if (!this.setorAtual) return;
    if (!this.entidade.usuario_setores) this.entidade.usuario_setores = [];
    if (this.entidade.usuario_setores.find(m => m.setor.id === this.setorAtual.id)) {
      warning(`Setor ${this.setorAtual.nome} já vinculado ao usuário!`);
    } else {
      this.entidade.usuario_setores.push({ setor: this.setorAtual });
    }

    this.setorAtual = undefined
  }

  public removerUsuarioSetor(item: UsuarioSetor, index: number) {
    if (!item) return

    this.entidade.usuario_setores.splice(index, 1);
  }

  public revelaHorarioAcesso() {
    // const horario_inicio = this.entidadeForm.get('horario_inicio').value ? this.entidadeForm.get('horario_inicio').value : this.entidade.horario_inicio
    // const horario_termino = this.entidadeForm.get('horario_termino').value ? this.entidadeForm.get('horario_termino').value : this.entidade.horario_termino
    // const administrador = this.entidadeForm.get('administrador').value

    // if (horario_inicio || horario_termino || !administrador) return true
    // else return false

    return (this.entidadeForm.get('horario_inicio').value ?? this.entidade.horario_inicio) || (this.entidadeForm.get('horario_termino').value ?? this.entidade.horario_termino) || !this.entidadeForm.get('administrador').value;
  }

  // public desabilitar() {
  //   if (this.entidade.solicitacao) {
  //     return 'disabled';
  //   }
  // }

  public vincularSetores(): void {
    try {
      if (this.liberaCampoSetor) {
        throw new Error('Preencha o estoque primeiro');
      }

      const parametros = Object.assign({}, this.carregarParametrosSetor());
      delete parametros.relations;

      this.setorService.filtrar(1, -1, parametros)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(res => {
          const setores = res.content as Setor[];
          const usuario = Object.assign({}, this.entidade);
          delete usuario.usuario_setores;

          const usuario_setores = setores.map<UsuarioSetor>(setor => {
            const { id, nome, codigo } = setor;
            const mappedSetor: Setor = { id, nome, codigo };
            return {
              setor: mappedSetor,
              usuario: { id: usuario.id }
            };
          });

          this.entidade.usuario_setores = usuario_setores;
          success('Setores atribuídos com sucesso');
        });
    } catch (err) {
      if (err instanceof Error) {
        error(err.message);
        console.error(err);
      } else {
        this.acaoErro(err);
      }
    }
  }

  public ativarSetores(): void {
    const estoqueForm = this.entidadeForm.get('estoque').value as Estoque;
    const estoquesForm = this.entidadeForm.get('usuario_estoques').value as Estoque[];

    this.liberaCampoSetor = (!estoquesForm.length && !estoqueForm);
  }

  preLoginAudesp() {
    if (!this.entidadeForm.get('login_audesp').value) {
      error('Necessário informar o login do AUDESP');
      return;
    }

    if (!this.entidadeForm.get('senha_audesp').value) {
      $('#dlgAudesp').modal('show');
    } else {
      this.loginAudesp();
    }
  }

  loginAudesp() {
    const credenciais = { login: '', senha: '' };
    credenciais.login = this.entidadeForm.get('login_audesp').value;
    credenciais.senha = (!this.entidadeForm.get('senha_audesp').value ? this.entidade.senha_audesp : this.entidadeForm.get('senha_audesp').value);

    if ((!credenciais.login || !credenciais.senha) || (credenciais.login == '' || credenciais.senha == '')) {
      error('Informe todos os dados para se autenticar no AUDESP');
      return;
    } else {
      this.audespService.loginAudesp(credenciais.login, credenciais.senha).pipe(takeUntil(this.unsubscribe)).subscribe((idTransacao) => {
        this.progressoService.show(idTransacao, (retorno) => {
          GlobalService.salvarSessaoLogin(this.login);
        });
      }, e => {
        this.messageService.add({ severity: 'error', summary: 'Erro', detail: e.error?.payload });
      });
    }
  }

  processarHistorico(item: any, chave: 'antes' | 'depois'): string {
    if (!item) return 'Sem registros';
    const registro = JSON.parse(item[chave]);
    if (!registro) return 'Sem registros';
    let historico = '';

    if (item.alvo.includes('Usuario')) {
      const formatacaoHistorico = this.getFormatacaoHistoricoUsuario(item, chave);
      historico += formatacaoHistorico;
    } else {
      if (registro['permissao'] !== undefined && registro['permissao'] !== null && item.pagina) {
        for (const p in Pagina) {
          if (Pagina[p] === item.pagina) {
            historico += (historico === '' ? '' : '\n') + p + ': ' + (registro['permissao'] === 0 ? 'Sem acesso' : (registro['permissao'] === 1 ? 'Visualizar' : 'Incluir/Alterar'));
          }
        }
      }
    }

    return historico;
  }

  public preencherPerfis() {
    if (this.entidade?.usuario_perfis_assinatura?.length && this.listaPerfis?.length) {
      this.perfis = this.entidade.usuario_perfis_assinatura
        .map(p => this.listaPerfis.find(lp => lp.id === p.perfil_assinatura.id))
        .filter(p => p);
    }
  }

  private nomesCampos: any = {
    administrador: 'Administrador',
    perfil_assinatura: 'Perfil de Assinatura',
    unidade: 'Unidade',
    favorecido: 'Favorecido',
    ativo: 'Ativo'
  };

  private formatarValor(jsonItemChave: any, campo: string): string {
    let valor = jsonItemChave?.[campo];

    if (valor === null || valor === undefined) return 'Não definido';
    if (campo === 'senha') return 'Nova senha';
    if (typeof valor === 'boolean') {
      return valor ? 'Sim' : 'Não';
    }

    if (typeof valor === 'object') {
      if (campo === 'perfil_assinatura') {
        let perfilAssinatura = this.listaPerfis.find(item => item.id == valor?.id);
        return perfilAssinatura.nome;
      } else if (campo === 'estoque') {
        let estoque = this.listaEstoque.find(item => item.id == valor?.id);
        if (estoque) {
          return estoque.nome;
        } else {
          return 'Não definido'
        }
      } else if (campo === 'setor') {
        let setor = this.listaSetor.find(item => item.id == valor?.id);
        if (setor) {
          return setor.nome;
        } else {
          return 'Não definido'
        }
      } else {
        return valor?.nome || valor?.descricao || valor?.id || 'Objeto';
      }
    }

    return valor.toString();
  }

  public getFormatacaoHistoricoUsuario(item: any, chave: string) {
    let alteracoes: string[] = [];
    let jsonItemChave = JSON.parse(item[chave]);
    let antes = JSON.parse(item.antes || '{}');
    let depois = JSON.parse(item.depois || '{}');

    let todasChaves = new Set([
      ...Object.keys(jsonItemChave || {}),
    ]);

    const camposIgnorados = new Set([
      'id',
      'usuario',
      'data_cadastro',
      'data_alteracao'
    ]);

    todasChaves.forEach(campo => {
      if (!camposIgnorados.has(campo)) {
        if (antes && antes?.[campo] && antes?.[campo]?.id === null) {
          antes[campo] = null;
        }
        if (JSON.stringify(antes?.[campo]) !== JSON.stringify(depois?.[campo])) {
          let campoFormatado = campo.replace(/_/g, ' ').replace(/\b\w/g, letra => letra.toUpperCase());
          alteracoes.push(
            `${this.nomesCampos[campo] || campoFormatado}: ${this.formatarValor(jsonItemChave, campo)}`
          );
        }
      }
    });

    if (alteracoes.length > 0) {
      return alteracoes.join('<br>');
    } else {
      return 'Nenhuma alteração';
    }
  }

  public sanitizarHistorico(lista: any[]): any[] {
    function normalizar(obj: any): any {
      if (obj === null || obj === undefined) return null;

      if (Array.isArray(obj)) {
        return obj.map(normalizar);
      }

      if (typeof obj === 'object') {
        const keys = Object.keys(obj);
        if (keys.length === 1 && keys[0] === 'id' && obj.id == null) {
          return null;
        }

        const novo: any = {};
        for (const key of keys) {
          novo[key] = normalizar(obj[key]);
        }

        return novo;
      }

      return obj;
    }

    return lista.filter(item => {
      if (item.operacao !== 'Alteração') return true;
      if (!item.antes && !item.depois) return false;
      if (!item.antes || !item.depois) return true;

      const antes = normalizar(JSON.parse(item.antes));
      const depois = normalizar(JSON.parse(item.depois));

      return JSON.stringify(antes) !== JSON.stringify(depois);
    });
  }

  carregando = false;

  carregarHistorico() {
    if (this.carregando) {
      return;
    }

    this.carregando = true;

    this.usuarioService
      .historico(this.entidade.id, this.paginaCorrente, this.limite)
      .subscribe({
        next: (res) => {
          this.listaHistorico = this.sanitizarHistorico(res.content);
          this.paginaTotal = res.totalPages;
        },
        error: (err) => {
          console.error(err);
        },
        complete: () => {
          this.carregando = false;
        }
      });
  }

  carregarTermosDeAceite() {
    if (this.carregando) {
      return;
    }

    this.carregando = true;

    this.termoAcessoUsuarioAceiteService
      .filtrar(this.paginaCorrente, this.limite, {
        'usuario.id': this.entidade.id,
        'relations': 'termo,storage',
        'orderBy': 'id$DESC'
      })
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        res => {
          this.listaTermos = res.content;
        },
        err => {
          error(err);
          throw err
        },
        () => this.carregando = false
      );
  }

  imprimirTermo(termo: TermoAcessoUsuarioAceite) {
    window.open(termo.storage.url, '_blank');
  }

  carregarPaginacaoDoHistorico() {
    this.usuarioService.historico(this.entidade.id, this.paginaCorrente, this.limite).subscribe(res => {
      this.listaHistorico = this.sanitizarHistorico(res.content);
    });
  }

  paginaAnterior() {
    this.paginaCorrente--;
    this.carregarPaginacaoDoHistorico();
  }

  proximaPagina() {
    this.paginaCorrente++;
    this.carregarPaginacaoDoHistorico();
  }

  paginaDigitada(p: number) {
    this.paginaCorrente = p;
    this.carregarPaginacaoDoHistorico();
  }

  mudarLimite(l: number) {
    this.limite = l;
    this.carregarPaginacaoDoHistorico();
  }
}
